import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isInlineFormEnabledForCopilotUsers } from './isCalendarEventFormV2Enabled';

/**
 * Checks if the Event Draft Assistant (BizChat sidepane) experience is enabled.
 * The conditions for enabling include feature flag(time-copilot-ida-draft-assistant), user copilot license, user copilot settings and event form copilot experience capability.
 * When enabled, routes calendar draft requests to the BizChat sidepane instead of inline skittle.
 */
export function isEventDraftAssistantEnabled(): boolean {
    return (
        isGlobalFeatureEnabled('time-copilot-ida-draft-assistant') &&
        isInlineFormEnabledForCopilotUsers()
    );
}

/**
 * Checks if the Event Draft Assistant is enabled for existing events.
 * When enabled, the button is shown on form open for existing events.
 * Gated by a separate flight so existing-event support can be rolled out independently.
 */
export function isEventDraftAssistantEnabledForExistingEvents(): boolean {
    return (
        isGlobalFeatureEnabled('time-copilot-ida-existing-events') &&
        isInlineFormEnabledForCopilotUsers()
    );
}

/**
 * Checks if the autodraft button in the old DraftCopilotPlugin should be enabled.
 * Returns false when the new DraftAgendaPlugin handles the button instead.
 */
export function isAutodraftButtonEnabled(): boolean {
    return (
        isGlobalFeatureEnabled('time-copilot-ida-autodraft-button') &&
        !isEventDraftAssistantEnabled()
    );
}
